import { AddressDetailsListSchema, AddressDetailsList } from "./bringAPISchema";

const API_URL = "/api/address";

export async function getAddresses(
    query: string,
): Promise<AddressDetailsList | null> {
    const url = `${API_URL}/suggestions?query=${query}`;

    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        return null;
    }

    const data = await response.json();
    const validatedData = AddressDetailsListSchema.parse(data);

    return validatedData;
}
